import { BellRing, CalendarClock, Sparkles, Wand2 } from 'lucide-react'

import AccordionMultiLevelDemo from '@/components/ui/accordion-multi-level'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'

const showcaseCards = [
  {
    id: 'leasing',
    title: 'Leasing Sprint',
    detail: '7 qualified leads this week',
    image:
      'https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1200&q=80',
  },
  {
    id: 'maintenance',
    title: 'Maintenance Queue',
    detail: '2 high-priority jobs pending',
    image:
      'https://images.unsplash.com/photo-1460317442991-0ec209397118?auto=format&fit=crop&w=1200&q=80',
  },
]

export default function DemoOne() {
  return (
    <div className="space-y-4" data-testid="ui-overhaul-demo">
      <Card className="overflow-hidden border-none bg-gradient-to-br from-cyan-100 via-white to-emerald-100">
        <CardHeader>
          <div className="flex flex-wrap items-center justify-between gap-3">
            <div>
              <Badge variant="info" className="mb-2">
                <Sparkles className="mr-1 h-3.5 w-3.5" />
                Demo Overhaul
              </Badge>
              <CardTitle className="text-2xl">RealAssist Component Command Deck</CardTitle>
              <p className="mt-1 text-sm text-slate-700">A responsive, production-ready showcase that combines accordion workflows, cards, buttons, and utility actions.</p>
            </div>
            <div className="flex flex-wrap gap-2">
              <Button variant="outline">
                <CalendarClock className="mr-2 h-4 w-4" />
                Schedule Preview
              </Button>
              <Button>
                <Wand2 className="mr-2 h-4 w-4" />
                Generate Report
              </Button>
            </div>
          </div>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col gap-2 sm:flex-row">
            <Input placeholder="Search modules, actions, or FAQ" className="bg-white" />
            <Button variant="secondary" className="sm:w-auto">
              <BellRing className="mr-2 h-4 w-4" />
              Notify Team
            </Button>
          </div>
        </CardContent>
      </Card>

      <div className="grid gap-4 lg:grid-cols-3">
        <Card className="lg:col-span-2">
          <CardHeader>
            <CardTitle>Multi-level Knowledge Accordion</CardTitle>
          </CardHeader>
          <CardContent className="flex justify-center">
            <AccordionMultiLevelDemo />
          </CardContent>
        </Card>

        <div className="space-y-4">
          {showcaseCards.map((item) => (
            <Card key={item.id} className="overflow-hidden">
              <img src={item.image} alt={item.title} className="h-28 w-full object-cover" loading="lazy" />
              <CardContent className="pt-4">
                <p className="font-semibold">{item.title}</p>
                <p className="mt-1 text-sm text-muted-foreground">{item.detail}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  )
}
